<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                现网基站图层
                <small>现网基站图层</small>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <a href="#">
                        <i class="fa fa-dashboard"></i> 现网基站图层
                    </a>
                </li>
                <li class="active">现网基站图层</li>
            </ol>
        </section>
        <!-- Main content -->
        <section class="content">
            <div class="col-sm-12">
                <div id="atptoolbar" style="margin-bottom:8px;">
                    <button
                            class="btn btn-default"
                            :class="{'btn-info':btnClass=='1'}"
                            type="button"
                            @click="selectStation('company','1')"
                    >
                        <i class="fa fa-filter"></i>&nbsp;我司基站
                    </button>
                    <button
                            class="btn btn-default"
                            :class="{'btn-info':btnClass=='0'}"
                            type="button"
                            @click="selectStation('','0')"
                    >
                        <i class="fa fa-university"></i>&nbsp;所有基站
                    </button>
                </div>
                <div id="map_container" style="width:100%;height:78vh;"></div>
            </div>
        </section>
        <!-- /.content -->
    </div>
</template>
<script>
  import AMap from 'AMap'

  var map
  var markers = []
  var selectedmark
  var infoWindow // 弹出框
  var geolocation

  export default {
    name: 'index',
    data () {
      return {
        // 默认经纬度
        lng: 116.32647,
        lat: 40.05159,
        // 公司id
        companyid: '',
        //按钮样式
        btnClass: '0' // 0 全部基站  1 我司基站
      }
    },
    created () {},
    mounted () {
      this.init() // 加载地图
      var companyInfo = localStorage.getItem('companyInfo')
      this.companyid = JSON.parse(companyInfo).id
    },
    methods: {
      // 我司基站 / 全部基站 param 我司company / 全部 ''
      selectStation: function (param, btnClass) {
        var self = this
        self.btnClass = btnClass
        self.getstation(self.lng, self.lat)
      },
      init: function () {
        var self = this
        map = new AMap.Map('map_container', {
          center: [self.lng, self.lat],
          resizeEnable: true,
          zoom: 14,
          layers: [new AMap.TileLayer.Satellite()]
        })
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function () {
          map.addControl(new AMap.ToolBar())
          map.addControl(new AMap.Scale())
        })

        map.plugin(
          ['AMap.Geolocation', 'AMap.ToolBar', 'AMap.InfoWindow'],
          function () {
            geolocation = new AMap.Geolocation({
              enableHighAccuracy: true, //是否使用高精度定位，默认:true
              timeout: 5000, //超过10秒后停止定位，默认：无穷大
              maximumAge: 0, //定位结果缓存0毫秒，默认：0
              convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
              showButton: true, //显示定位按钮，默认：true
              buttonPosition: 'LB', //定位按钮停靠位置，默认：'LB'，左下角
              buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
              showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
              showCircle: false, //定位成功后用圆圈表示定位精度范围，默认：true
              panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
              zoomToAccuracy: false //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
            })
            map.addControl(new AMap.ToolBar())
            map.addControl(geolocation)
            geolocation.getCurrentPosition()
            AMap.event.addListener(geolocation, 'complete', self.onComplete)
            AMap.event.addListener(geolocation, 'error', self.onError)
          }
        )
      },
      // 定位失败执行的函数
      onError: function (data) {
        var self = this
        console.log('定位失败~~~')
        self.getstation(self.lng, self.lat)
        map.on('moveend', function () {
          //地图平移结束事件
          var center = map.getCenter()
          self.lng = center.lng
          self.lat = center.lat
          self.getstation(center.lng, center.lat)
        })
      },
      // 定位成功之后执行的函数
      onComplete: function () {
        var self = this
        var center = map.getCenter()
        self.getstation(center.lng, center.lat)
        self.lng = center.lng
        self.lat = center.lat
        map.on('moveend', function () {
          //地图平移结束事件
          var center = map.getCenter()
          self.lng = center.lng
          self.lat = center.lat
          self.getstation(center.lng, center.lat)
        })
      },

      getstation: function (lng, lat) {
        //清除过期的大头针
        map.remove(markers)
        markers = []
        var self = this
        var org_id = ''
        if (self.btnClass == '1') {
          org_id = self.companyid
        }
        self.global.axiosGet(
          self,
          'stations/?lng=' + lng + '&lat=' + lat + '&org_id=' + org_id,
          function (stations) {
            var stations = stations.rows
            var marker
            var markericon
            var markericontype
            var markersizewidth
            var markersizeheight
            var markercontent

            for (var i = 0; i < stations.length; i++) {
              switch (stations[i].stst_comm) {
                case '中国移动': {
                  markericontype = 'cmcc'
                  break
                }
                case '中国电信': {
                  markericontype = 'telecom'
                  break
                }
                case '中国联通': {
                  markericontype = 'unicom'
                  break
                }
                case '中国铁塔': {
                  markericontype = 'tower'
                  break
                }
                default: {
                  console.log('存在未知基站:' + stations[i].stst_atpid)
                  continue
                }
              }

              markericon = new AMap.Icon({
                image: '/static/icon_' + markericontype + '_40.png',
                size: new AMap.Size(40, 40)
              })

              marker = new AMap.Marker({
                map: map,
                icon: markericon,
                position: [stations[i].stst_longitude, stations[i].stst_latitude],
                zIndex: 101,
                size: new AMap.Size(10, 10),
                offset: new AMap.Pixel(-20, -20),
                extData: stations[i]
              })
              marker.on('click', self.markerClick)
              markers.push(marker)
            }
          }
        )
      },
      markerClick: function (e) {
        selectedmark = e.target
        var extData = e.target.getExtData()
        console.log(extData)
        var info = [], stst_commname, stst_type, stst_address
        extData['stst_commname'] ? stst_commname = extData['stst_commname'] : extData['stst_commname'] = ''
        extData['stst_type'] ? stst_type = extData['stst_type'] : stst_type = '-'
        extData['stst_address'] ? stst_address = extData['stst_address'] : stst_address = '暂无'
        info.push('<div style=\'padding:0px 0px 0px 4px;\'>基站名称: <b>' + stst_commname + '</b>')
        info.push('基站类型: ' + stst_type)
        info.push('基站地址: ' + stst_address + '</div></div>')
        infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, 0) })
        infoWindow.setContent(info.join('<br/>'))
        infoWindow.open(map, e.target.getPosition())
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/stationOnMap.vue